import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'
import React, { createContext, useContext } from 'react'

export interface AcompanhamentoCondicaoSaudeContextValue {
  tematica?: AcompanhamentoCondicaoSaudeTematicaEnum
  cidsConsiderados: ReadonlyArray<string>
  ciapsConsiderados: ReadonlyArray<string>
}

const defaultValue: AcompanhamentoCondicaoSaudeContextValue = {
  tematica: undefined,
  cidsConsiderados: [],
  ciapsConsiderados: [],
}

const AcompanhamentoCondicaoSaudeContext = createContext<AcompanhamentoCondicaoSaudeContextValue>(defaultValue)

export interface AcompanhamentoCondicaoSaudeProviderProps {
  value: AcompanhamentoCondicaoSaudeContextValue
  children: React.ReactNode
}

export function AcompanhamentoCondicaoSaudeProvider({
  value,
  children,
}: Readonly<AcompanhamentoCondicaoSaudeProviderProps>) {
  return (
    <AcompanhamentoCondicaoSaudeContext.Provider value={value}>{children}</AcompanhamentoCondicaoSaudeContext.Provider>
  )
}

export function useAcompanhamentoCondicaoSaudeContext() {
  return useContext(AcompanhamentoCondicaoSaudeContext)
}
